import React, { useEffect } from "react";
import Card from "./Card";
import Navbar from "../../../Layout/Navbar/Navbar";
import "./Lectures.css";

const Home = () => {
  useEffect(() => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  }, []);

  return (
    <div>
      <Navbar />
      <div className="lectures-page">
        <div className="lectures-header">
          <div className="lectures-header-icon">
            <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="#fff" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
              <path d="M9 18V5l12-2v13"/><circle cx="6" cy="18" r="3"/><circle cx="18" cy="16" r="3"/>
            </svg>
          </div>
          <div>
            <h1 className="lectures-title">Sakeenat Institute Lectures</h1>
            <p className="lectures-subtitle">Audio lecture collection by Aalima Nikhat Haider Aapa</p>
          </div>
        </div>
        <Card />
      </div>
    </div>
  );
};

export default Home;
